let productList = [
    {
        id: 0,
        price: 3.99,
        img: '../public/img/product.png',
    },
    {
        id: 1,
        price: 8.99,
        img: "../public/img/temp01.webp",
    },
    {
        id: 2,
        price: 2.00,
        img: "../public/img/temp01.webp",
    },

]

export default productList;